'use strict';
define(['xhr-promise', '../../data/config/app', './../Constant', './Breakpoint', '../links/cookieService'], function (XhrPromise, config, constant, Breakpoint, cookieService) {
    var countryData = null;

    return {
        buildDropDown: function () {
            this.headerEL = document.querySelector('.navigation-common-hdr-main');
            var loadCountryDom = this.loadCountryDom.bind(this);
            var updateLanguageDropdown = this.updateLanguageDropdown.bind(this);
            var changeLanguageDropdown = this.changeLanguageDropdown.bind(this);

            this.countryDomMobile = document.querySelector('.navigation-country-mobile--country-list');
            this.countryDom = document.querySelector('.navigation-country-overlay--country-list');
            var ariaLabel = (config && config.storeId === constant.ukId) ? constant.ukCountryNameI : constant.ieCountryNameI;
            window.analyticsNavCountryName = (config && config.storeId === constant.ukId) ? constant.ukFlagID : constant.ieFlagID;
            window.analyticsNavCountryLanguage = 'English';

            if ((Breakpoint.size() === 'xsmall') && this.countryDomMobile.childElementCount === 0) {
                this.languageDomMobile = document.querySelector('.navigation-country-mobile--language-list');
                this.finalLinkMobile = document.querySelector('.navigation-country-mobile--link');
                this.dropDownFlagMobile = document.querySelector('#navigation-flags-overlay-mobile');
                this.countryDomMobile.addEventListener('change', updateLanguageDropdown);
                this.languageDomMobile.addEventListener('change', changeLanguageDropdown);
                this.finalLinkMobile.addEventListener('click', cookieService.updatePreferredCountryCookie);

                this.finalLinkMobile.href = 'javascript:;';

                var elementMob = document.createElement('option');
                elementMob.innerText = (config && config.storeId === constant.ukId) ? constant.ukCountryName : constant.ieCountryName;
                elementMob.value = '0';
                elementMob.setAttribute('data-lang', window.analyticsNavCountryName);
                elementMob.setAttribute('aria-label', ariaLabel);
                this.countryDomMobile.appendChild(elementMob);
                var langElementMob = document.createElement('option');
                langElementMob.innerText = 'English';
                langElementMob.value = 'javascript:;';
                this.languageDomMobile.appendChild(langElementMob);
                this.loadCountryData(loadCountryDom);
            }
            else if (Breakpoint.size() !== 'xsmall' && this.countryDom.childElementCount === 0) {
                this.languageDom = document.querySelector('.navigation-country-overlay--language-list');
                this.finalLink = document.querySelector('.navigation-country-overlay--link');
                this.dropDownFlag = document.querySelector('#navigation-flags-overlay-desktop');
                this.finalLink.addEventListener('click', cookieService.updatePreferredCountryCookie);

                this.countryDom.addEventListener('change', updateLanguageDropdown);
                this.languageDom.addEventListener('change', changeLanguageDropdown);

                this.finalLink.href = 'javascript:;';

                var element = document.createElement('option');
                element.innerText = (config && config.storeId === constant.ukId) ? constant.ukCountryName : constant.ieCountryName;
                element.value = '0';
                element.setAttribute('data-lang', window.analyticsNavCountryName);
                element.setAttribute('aria-label', ariaLabel);
                this.countryDom.appendChild(element);
                var langElement = document.createElement('option');
                langElement.innerText = 'English';
                langElement.value = 'javascript:;';
                this.languageDom.appendChild(langElement);
                this.loadCountryData(loadCountryDom);
            }
        },

        loadCountryDom: function (data) {
            window.analyticsCountryData = data;
            countryData = data.countryLinks;
            var spriteImage = data.countryFlagLink;
            var img = document.createElement('img');
            img.src = spriteImage;
            if (countryData) {
                for (var i = 0; i < countryData.length; i++) {
                    var countryName = countryData[i].imgPath + ' ( ' + countryData[i].currency + ' )';
                    var element = document.createElement('option');
                    element.innerText = countryName;
                    element.value = 1 + i;
                    element.setAttribute('aria-label', countryData[i].imgPath);
                    element.setAttribute('data-lang', countryData[i].langId);
                    if (Breakpoint.size() === 'xsmall') {
                        this.countryDomMobile.appendChild(element);
                    } else {
                        this.countryDom.appendChild(element);
                    }
                }
                if (this.dropDownFlagMobile) {
                    this.dropDownFlagMobile.style.backgroundImage = 'url("' + spriteImage + '")';
                    document.querySelector('.navigation-mobile-country-selector .navigation-lazyload').style.display = 'none';
                }
                if (this.dropDownFlag) {
                    this.dropDownFlag.style.backgroundImage = 'url("' + spriteImage + '")';
                    document.querySelector('.navigation-country-overlay--dropdown .navigation-lazyload').style.display = 'none';
                }
            }
        },

        loadCountryData: function (callback) {
            this.config = window.mnsHeaderConfig;
            var xhrp = new XhrPromise();

            xhrp.send({
                url: this.config.wcsBaseUrl + this.config.CMD.countryLinks + '?catalogId=' + this.config.catalogId + '&langId=' + this.config.langId + '&storeId=' + this.config.storeId,
                method: 'GET'
            })
                .then(function (response) {
                    if (response.status === 200) {
                        callback(response.responseText);
                    }
                })
                .catch(function () {
                    //Handle errors here
                    callback([]);
                });
        },

        updateLanguageDropdown: function () {
            var lanDom = this.languageDom,
                finalLink = this.finalLink,
                countryDom = this.countryDom,
                dropDownFlag = this.dropDownFlag;
            if (Breakpoint.size() === 'xsmall') {
                lanDom = this.languageDomMobile;
                finalLink = this.finalLinkMobile;
                countryDom = this.countryDomMobile;
                dropDownFlag = this.dropDownFlagMobile;
            }
            if (lanDom && finalLink && countryDom && dropDownFlag) {
                lanDom.innerHTML = '';
                var langClass = dropDownFlag.classList[1];
                if (countryDom.value === '0') {
                    finalLink.href = 'javascript:;';
                    var defaultElement = document.createElement('option');
                    defaultElement.innerText = 'English';
                    defaultElement.value = 'javascript:;';
                    lanDom.appendChild(defaultElement);
                    var defaultName = (config && config.storeId === constant.ukId) ? constant.ukFlagID : constant.ieFlagID;
                    var defaultFLagClass = dropDownFlag.classList[0] + '--' + defaultName;
                    dropDownFlag.classList.remove(langClass);
                    dropDownFlag.classList.add(defaultFLagClass);
                    window.analyticsNavCountryName = defaultName;
                    window.analyticsNavCountryLanguage = 'English';
                }
                else {
                    var index = countryDom.value - 1;
                    var langList = countryData[index].langOptions;
                    var orgC = (config && config.storeId === constant.ukId) ? 'uk' : 'ie';
                    finalLink.href = langList[0].URL + '?intid=' + orgC.toLowerCase() + '_header_country-redirect_' + countryData[index].name.toLowerCase() + '_countryselector';
                    finalLink.setAttribute('data-lang', countryData[index].lang);
                    finalLink.setAttribute('data-countryname', countryData[index].name);
                    var newLangClass = dropDownFlag.classList[0] + '--' + countryData[index].name;
                    dropDownFlag.classList.remove(langClass);
                    dropDownFlag.classList.add(newLangClass);
                    for (var i = 0; i < langList.length; i++) {
                        var langElement = document.createElement('option');
                        langElement.innerText = langList[i].Language;
                        langElement.value = langList[i].URL;
                        langElement.setAttribute('data-lang', countryData[index].lang);
                        langElement.setAttribute('data-countryname', countryData[index].name);
                        lanDom.appendChild(langElement);
                    }
                    window.analyticsNavCountryName = countryData[index].name;
                    window.analyticsNavCountryLanguage = langList[0].Language;
                }
            }
        },

        changeLanguageDropdown: function () {
            if (Breakpoint.size() === 'xsmall') {
                this.finalLinkMobile.href = this.languageDomMobile.value;
                var langMob = this.languageDomMobile.getAttribute('data-lang'),
                    nameMob = this.languageDomMobile.getAttribute('data-countryname');
                this.finalLinkMobile.setAttribute('data-lang', langMob);
                this.finalLinkMobile.setAttribute('data-countryname', nameMob);
            } else {
                this.finalLink.href = this.languageDom.value;
                var lang = this.languageDom.getAttribute('data-lang'),
                    name = this.languageDom.getAttribute('data-countryname');
                this.finalLink.setAttribute('data-lang', lang);
                this.finalLink.setAttribute('data-countryname', name);
            }
        },

        resetDropDown: function () {
            if (countryData !== null) {
                if (Breakpoint.size() === 'xsmall') {
                    this.countryDomMobile.value = 0;
                } else {
                    this.countryDom.value = 0;
                }
                this.updateLanguageDropdown();
            }
        }
    };
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/CountryLinks.js